import { useMutation } from '@tanstack/react-query';
import { API_URL, fetchWrapper } from 'src/common/utils/api/fetchWrapper';

export type TranscriptSegment = {
  speaker: string | null;
  content: string;
  startTime: string | null;
  endTime: string | null;
};

export type Guest = {
  name: string;
  description?: string;
};

export type FamilyMember = {
  name: string;
  role?: string;
};

export type ParticipantNamesInput = {
  advisorNames: string[];
  clientNames: string[];
  guests: Guest[];
  unmatchedAttendeeEmails: string[];
  familyMembers: FamilyMember[];
  clientIds: string[];
};

export type CleanTranscriptResult = {
  dataUploadFileId: string;
  rawSegments: TranscriptSegment[];
  cleanedSegments: TranscriptSegment[];
  advisorNames: string[];
  clientNames: string[];
  guestNames: string[];
};

type ProcessTranscriptPayload = {
  companyId: string;
  audio: File;
  participants: ParticipantNamesInput;
};

export const useProcessTranscript = () => {
  const { mutateAsync, isPending, error, reset } = useMutation<
    { data: CleanTranscriptResult },
    Error,
    ProcessTranscriptPayload
  >({
    mutationFn: ({ companyId, audio, participants }) => {
      const form = new FormData();
      form.append('audio', audio);
      form.append('participants', JSON.stringify(participants));
      return fetchWrapper(
        `${API_URL}/admin/companies/${companyId}/transcript-tester/process`,
        { method: 'POST', body: form },
        'POST transcript-tester/process',
        { timeoutMs: 600_000 },
      ) as Promise<{ data: CleanTranscriptResult }>;
    },
  });

  return { process: mutateAsync, isProcessing: isPending, error, reset };
};
